import { useQuery } from 'react-query'

import { fetchQuote } from '@views/quotes/query-api'

import { QueryKeys } from '../../../enums/queryKeys'

interface UseFetchQuoteOptions {
  enabled?: boolean
  // false disables retries for on-demand refetches that need immediate failure feedback
  retry?: boolean
}

export const useFetchQuote = (quoteId?: string, { enabled = true, retry }: UseFetchQuoteOptions = {}) => {
  const {
    data: quoteData,
    isLoading,
    refetch,
    ...rest
  } = useQuery([QueryKeys.Quote, quoteId], () => fetchQuote(quoteId || ''), {
    enabled: !!quoteId && enabled,
    retry,
  })

  return { quote: quoteData?.data, isLoading, refetch, ...rest }
}
